module.exports = __webpack_public_path__ + "img/php.44403f1e.svg";